<template>
    <div>
        <div class="outer-content">
            <div class="inner-content">
                <div class="upper-panel">
                    <div class="header" v-html="T('Select_Game_Mode')"></div>
                </div>
                <div class="button-container position-absolute w-100 d-flex justify-content-center align-items-center">
                    <div class="button-container-inner d-flex justify-content-between align-items-center">
                        <div class="game-mode-button" @click="$emit('single-player')">
                            <div class="game-mode-button-circle game-mode-button-circle-singleplayer"></div>
                            <div class="game-mode-text" v-html="T('Game_Mode_1')"></div>
                        </div>
                        <div class="game-mode-button" @click="$emit('multi-player')">
                            <div class="game-mode-button-circle game-mode-button-circle-multiplayer"></div>
                            <div class="game-mode-text" v-html="T('Game_Mode_2_a')"></div>
                            <div class="game-mode-text-lower" v-html="T('Game_Mode_2_b')"></div>
                        </div>
                    </div>
                </div>
                <div class="shared-back-button" v-html="T('button_back')" @click="$emit('back')">
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'GameMode',

    data() {
        return {
            pin: ""
        };
    },
    methods: {
        T(key: string): string {
            return T(key);
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.game-mode-button-circle {
    width: 278px;
    height: 278px;
    margin-left: auto;
    margin-right: auto;
}

.game-mode-button-circle-singleplayer {
    background: url("../assets-fca/UI/icon_single_player.svg")
}

.game-mode-button-circle-multiplayer {
    background: url("../assets-fca/UI/icon_multi_player.svg");
}
</style>